"use client";

import { cn } from "@guru/shared/utils/cn";
import type React from "react";
import { useRef } from "react";

type SpotlightCardProps = React.HTMLAttributes<HTMLDivElement>;

/**
 * Card whose soft saffron glow follows the pointer — the painting happens in
 * CSS (.spotlight-card); this only feeds the cursor position into custom
 * properties. Hidden entirely under prefers-reduced-motion.
 */
export function SpotlightCard({ className, children, ...rest }: SpotlightCardProps) {
  const ref = useRef<HTMLDivElement>(null);

  const handlePointerMove = (event: React.PointerEvent<HTMLDivElement>) => {
    const element = ref.current;
    if (!element) return;
    const rect = element.getBoundingClientRect();
    element.style.setProperty("--spot-x", `${event.clientX - rect.left}px`);
    element.style.setProperty("--spot-y", `${event.clientY - rect.top}px`);
  };

  return (
    <div
      ref={ref}
      onPointerMove={handlePointerMove}
      className={cn("spotlight-card", className)}
      {...rest}
    >
      {children}
    </div>
  );
}
